import type {
  SelectContentProps,
  MultiSelectOption,
} from 'components/ui/Forms';

type OptionTypeBase = {
  [key: string]: any;
}

export function optionsMapper(input: OptionTypeBase): SelectContentProps {
  return {
    name: input.label,
    value: typeof input.value === 'number' ? input.value.toString() : input.value,
  };
}

export function multiSelectorOptionsMapper(
  input: OptionTypeBase,
): MultiSelectOption {
  return {
    label: input.label,
    value:
      typeof input.value === 'number' ? input.value.toString() : input.value,
  };
}
